<template>
	<div>
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/pop/pd/pd.png" class="steps step1" v-if="status==1">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"我知道了":"我知道了"}}
			</div>
			<div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
		<breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'交互计划'}]" />
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="客户名称">
								<el-input v-model="q.euNameLike" placeholder="请输入用户名称" :clearable="false"></el-input>
							</el-form-item>
							<el-form-item label="提报人" v-if="gly">
								<el-input v-model="q.cunameLike" placeholder="请输入提报人名称" :clearable="false"></el-input>
							</el-form-item>
							<el-form-item label="拜访时间" class="timesdetail" style="width: 50%;">
								<el-date-picker
									v-model="q.planTimeStartBegin"
									:clearable="false"
									type="date"
									 @change="beginDate(q)"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									v-model="q.planTimeEndEnd"
									:clearable="false"
									type="date"
									 @change="processDate(q)"
									value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="交互类别">
										<brselect style="width:100%" category="userCareType" :v="q.euType" v-model="q.euType" placeholder="请选择"
										 :clearable="true"></brselect>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
					</el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置
							</el-button>
							<el-button v-auth="'cjweekplan'" class="h-btn h-formBtn h-bggreen" @click="weekplanCreate" style="position:relative;z-index:1;">创建周计划</el-button>
							<el-button v-auth="'planStatus'" class="h-btn h-formBtn h-bggreen" @click="subplan" style="position:relative;z-index:1;">周计划提报情况</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="h-row">
				<div class="h-rowIn" style="width: 57%;">
					<div style="height: 8.7rem;overflow: hidden;background-color: white;position: relative;">
						<div class="h-rowBox" style="border-bottom: none;box-shadow: none;">
							<div class="h-rowTitle h-pdl0">
								<div class="h-el-tab">
									<ul>
										<li :class="{'h-active':index==indx}" v-for="(item,index) in list" :key="index" @click="tabIndex(index)"><a>{{item}}</a></li>
									</ul>
								</div>
							</div>
							<el-checkbox-group v-model="checkedCities" class="h-todoCheckOut selectcheckbox" @change="handleCheckedCitiesChange">
								<div class="selectbbbb" v-for="(item,index) in tableData" :key="item.id">
									<el-checkbox :label="index+1"></el-checkbox>
									<div class="h-todoCheck" @click="checkDetail(item.id)" style="cursor:pointer;padding: 0.15rem 0;">
										<div style="display:flex;align-items:center;width:80%">
											<el-tag v-if="item.executionId" class="ljj_tags h-label h-greenLabel">{{item.euName?_.trim(item.euName).substr(0,1):'佚'}}</el-tag>
											<el-tag v-else-if="item.planTimeEnd.split(' ')[0]>=$util.riQi3(tdate)" class="ljj_tags h-label h-blueLabel">{{item.euName?item.euName.substr(0,1):''}}</el-tag>
											<el-tag v-else-if="$util.riQi3(tdate)>item.planTimeEnd.split(' ')[0]" class="ljj_tags h-label h-orangeLabel">{{item.euName?item.euName.substr(0,1):''}}</el-tag>
											<a class="h-ellipsis" :title="item.euName">{{item.euName}}</a>
											<span class="h-todoLabel" v-if="item.contact">{{item.contact}}</span>
											<span class="h-todoTime" v-if="item.planTimeEnd.split(' ')[0]!=item.planTimeStart.split(' ')[0]">
												{{item.planTimeStart.substr(0,10)}}--{{item.planTimeEnd.substr(0,10)}}</span>
											<span class="h-todoTime" v-if="item.planTimeEnd.split(' ')[0]==item.planTimeStart.split(' ')[0]">{{item.planTimeEnd.split(' ')[0]}}</span>
										</div>
										<span class="cuname" v-show="gly">{{item.cuname}}</span>
										<el-tag v-if="item.executionId" class="ljj_tags h-label2 h-greenLabel h-fr">已完成</el-tag>
										<el-tag v-else-if="item.planTimeEnd.split(' ')[0]>=$util.riQi3(tdate)" class="ljj_tags h-label2 h-blueLabel h-fr">未开始</el-tag>
										<el-tag v-else-if="$util.riQi3(tdate)>item.planTimeEnd.split(' ')[0]" class="ljj_tags h-label2 h-orangeLabel h-fr">未完成</el-tag>
									</div>
								</div>
							</el-checkbox-group>
							<div class="fenyes">
								<paginationmin :page="q" @query="query" />
							</div>
							<div v-if="tableData.length<5" style="display:flex;justify-content:center;padding-top: 30px;align-items: center;">
								<img src="../../assets/images/mylittle.png" alt="" style="width: 75%;">
							</div>
							<div class="h-rowBoxB h-rowBoxBtnOut" style="display: flex;align-items: center;margin: 0;padding: 0.11rem 0.26rem;position: absolute;bottom: 0;left: 0;width: 100%;border: 1px solid #d7e0f1;height: 67px;">
								<el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
								<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出
								</el-button>
								<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button>
								<uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="ghplanImportExcel"
								 :startrow="3" @callback="uploadExcelFilecallback" />
							</div>
						</div>
					</div>
				</div>
				<div class="h-rowIn" style="width: 43%;">
					<div style="height: 8.7rem;overflow-y: auto;background-color: white;padding: 0;position: relative;">
						<div class="h-rowBox">
							<div class="h-rowTitle" v-show="ifchart">
								<div class="h-disTable">
									<div class="h-tableCell">
										<h1>计划详情</h1>
									</div>
								</div>
							</div>
							<div class="h-rowCon">
								<div v-show="ifchart">
									<div class="h-gaugePieChart" id="h_gaugePie" style="width:100%;height:4rem; "></div>
									<div class="totals" v-if="this.indx ==0">全部 {{chartPer.all}}</div>
									<div class="totals" v-if="this.indx ==1">已拜访 {{chartPer.done}}</div>
									<div class="totals" v-if="this.indx ==2">未完成 {{chartPer.undo}}</div>
									<div class="totals" v-if="this.indx ==3">未开始 {{chartPer.todo}}</div>
									<div class="h-gaugePieLegend">
										<div class="h-gpLegendLi">
											<i class="h-greenBgLegend"></i>
											<p style="display: inline;">已拜访</p>
										</div>
										<div class="h-gpLegendLi">
											<i class="h-blueBgLegend"></i>
											<!-- <span>{{chartPer.todo}}</span> -->
											<p style="display: inline;">未开始</p>
										</div>
										<div class="h-gpLegendLi">
											<i class="h-orangeBgLegend"></i>
											<!-- <span>{{chartPer.undo}}</span> -->
											<p style="display: inline;">未完成</p>
										</div>
									</div>
								</div>
								<div class="h-runningDetail" v-show="detailShow">
									<div class="h-rdTitle">
										<h1>{{qdetail.euName}}</h1>
										<label v-if="qdetail.executionId">已拜访</label>
										<label v-if="!qdetail.executionId">未拜访</label>
										<label v-if="detailShow3">已转化需求</label>
									</div>
									<div class="h-rdForm" style="overflow-y: auto;height: 6.3rem;">
										<div class="h-rdFormWrap" style="width:100%;text-align:left;height: auto">
											<p class="h-grayFont">洽谈内容</p>
											<el-input type="textarea" maxlength="200" :value="qdetail.planRemark?qdetail.planRemark:''" readonly></el-input>
											<!-- <p>{{qdetail.planRemark?qdetail.planRemark:''}}</p> -->
										</div>
										<div class="h-rdFormWrap" style="width:100%;text-align:left;height: auto">
											<p class="h-grayFont">洽谈结果</p>
											<p :title="qdetail.userCareExecution?qdetail.userCareExecution.result:''">{{qdetail.userCareExecution?qdetail.userCareExecution.result:''}}</p>
										</div>
										<div class="h-rdFormWrap" style="width:100%;height:0.5rem">
											<p class="h-grayFont" style="display:inline-block;margin-right:0.3rem">拜访时间</p>
											<div v-if="qdetail.ex" style="display:inline-block"></div>
											<p v-if="qdetail.planTimeEnd && qdetail.planTimeEnd.split(' ')[0]!=qdetail.planTimeStart.split(' ')[0]"
											 style="display:inline-block">{{qdetail.planTimeStart.substr(0,10)}} -- {{qdetail.planTimeEnd.substr(0,10)}}</p>
											<p v-if="qdetail.planTimeEnd && qdetail.planTimeEnd.split(' ')[0]==qdetail.planTimeStart.split(' ')[0]"
											 style="display:inline-block">{{qdetail.planTimeEnd.split(' ')[0]}}</p>
										</div>
										<div class="h-rdFormWrap" style="text-align:left;">
											<p class="h-grayFont">负责人</p>
											<p>{{qdetail.contact}}</p>
										</div>
										<div class="h-rdFormWrap">
											<p class="h-grayFont">部门/科室</p>
											<p>{{qdetail.contactDept}}</p>
										</div>
										<div class="h-rdFormWrap" style="text-align:right;">
											<p class="h-grayFont">拜访对象</p>
											<div v-if="qdetail.euType">
												<p>
													<dictname category="userCareType" :v="qdetail.euType" />
												</p>
											</div>
										</div>
										<div class="h-rdFormWrap" style="text-align:left;">
											<p class="h-grayFont">联系方式</p>
											<p>{{qdetail.contactPhone}}</p>
										</div>
										<div class="h-rdFormWrap">
											<p class="h-grayFont" style="color:#fff">&nbsp;</p>
										</div>
										<div class="h-rdFormWrap">
											<p class="h-grayFont" style="color:#fff">&nbsp;</p>
										</div>
										
										<div class="h-rdFormWrap" style="width:100%;text-align:left;height: auto">
											<p class="h-grayFont">交互图片</p>
											<ul>
												<li v-for="(item,index) in PhotoList" :key="index">
                          <el-image
                              style="width: 0.6rem;height: 0.6rem;"
                              :src="item.saveurl"
                              :preview-src-list="srcList">
                          </el-image>
<!--													<img :src="item.saveurl" style="width: 0.6rem;height: 0.6rem;">-->
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
							<div class="h-rowBoxB h-rowBoxBtnOut" style="margin: 0;padding: 0.11rem 0.26rem;position: absolute;bottom: 0;left: 0;width: 100%;border: 1px solid #d7e0f1;height: 67px;display: flex;align-items: center;">
								<el-button v-auth="'zhuanxuqiu'" class="h-btn h-formBtn h-bgblueQ2" @click="transforxq" v-show="detailShow2">一键转化需求
								</el-button>
								<el-button v-auth="'zhuanxuqiu'" class="h-btn h-formBtn" v-show="!detailShow2" style="background-color: #d4d4d4;border-color: #d4d4d4;">一键转化需求
								</el-button>
								<!-- <el-button class="h-btn h-formBtn h-bgwhite2">取消 </el-button> -->
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
				<div class="h-dialogImg">
					<div class="h-disTable">
						<div class="h-tableCell">
							<h1>新建交互计划</h1>
							<p>New Care Plan</p>
						</div>
					</div>
				</div>
				<div class="h-formLine">
					<el-form :v-model="formLabelAlign2" label-position="right" :rules="rules2" ref="formLabelAlign2" :inline="true"
					 class="demo-ruleForm h-formbLine h-dialogForm">
						<el-form-item label="拜访客户" class="h-elformWrap-2">
							<el-select placeholder="请选择" v-model="formLabelAlign2.name1">
								<el-option label="青岛大学附属医院" value="type1"></el-option>
								<el-option label="类型二" value="type2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="拜访类型" class="h-elformWrap-2">
							<el-select placeholder="请选择" v-model="formLabelAlign2.name2">
								<el-option label="常规拜访" value="type1"></el-option>
								<el-option label="类型二" value="type2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="拜访时间" class="h-elformWrap-1">
							<el-col :span="11">
								<el-date-picker v-model="formLabelAlign2.name3" type="datetime" placeholder="选择时间" style="width: 100%;"></el-date-picker>
							</el-col>
							<el-col class="line h-txtCenter" :span="2">至</el-col>
							<el-col :span="11">
								<el-time-picker v-model="formLabelAlign2.name4" type="datetime" placeholder="选择时间" style="width: 100%;"></el-time-picker>
							</el-col>
						</el-form-item>
						<el-form-item label="用户渠道" class="h-elformWrap-2">
							<el-select placeholder="请选择" v-model="formLabelAlign2.name5">
								<el-option label="常规拜访" value="type1"></el-option>
								<el-option label="类型二" value="type2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="区域" class="h-elformWrap-2 h-regionForm">
							<el-col :span="8">
								<el-select placeholder="省" v-model="formLabelAlign2.name6">
									<el-option label="山东省" value="province1"></el-option>
									<el-option label="河北省" value="province2"></el-option>
								</el-select>
							</el-col>
							<el-col :span="8">
								<el-select placeholder="市" v-model="formLabelAlign2.name7">
									<el-option label="青岛市" value="city1"></el-option>
									<el-option label="济南市" value="city2"></el-option>
								</el-select>
							</el-col>
							<el-col class="line" :span="1"></el-col>
							<el-col :span="8">
								<el-select placeholder="区" v-model="formLabelAlign2.name8">
									<el-option label="青岛市" value="area1"></el-option>
									<el-option label="济南市" value="area2"></el-option>
								</el-select>
							</el-col>
						</el-form-item>
					</el-form>
					<div class="h-formPiece">
						<div v-for="(item,index) in planList" :key="index" class="planList">
							<el-form :v-model="item" label-position="right" :rules="rules2" ref="formLabelAlign2" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
								<el-form-item label="部门科室" class="h-elformWrap-1">
									<el-input v-model="item.name9"></el-input>
								</el-form-item>
								<el-form-item label="姓名" class="h-elformWrap-2">
									<el-input v-model="item.name10"></el-input>
								</el-form-item>
								<el-form-item label="联系方式" class="h-elformWrap-2">
									<el-input v-model="item.name11"></el-input>
								</el-form-item>
								<el-form-item label="洽谈内容" class="h-elformWrap-1">
									<el-input v-model="item.name12"></el-input>
								</el-form-item>
								<a class="" v-if="index<=0" @click="addplanList"><span>+</span></a>
								<a class="" v-else @click="delplanList"><span>-</span></a>
							</el-form>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
					<el-button class="h-btn h-formBtn h-bgblueQ2" @click="dialogFormVisible = false">提交新增计划</el-button>
				</div>
			</el-dialog>
			<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible1" class="h-dialog2">
				<div class="h-dialogImg">
					<div class="h-disTable">
						<div class="h-tableCell">
							<h1>选择需求类型</h1>
							<p>Choose Style</p>
						</div>
					</div>
				</div>
				<div class="h-formLines">
					<div class="xuqiuBoxList">
						<div class="xuqiulist" :class="{'active':xuqiudex==index}" v-for="(item,index) in xuqiuList" :key="index" @click="xuqiuGo(index)">
							<p>{{item}}</p>
							<img v-if="xuqiudex==index" src="../../assets/images/checkBox.png" style="margin-left:20px;" />
						</div>
					</div>
					<div class="xuqiutext" style="margin-top:30px;"><span style="color:#f46071">*</span>资源需求是指拜访用户时发现的需要其他部门协助解决的问题</div>
					<div class="xuqiutext"><span style="color:#f46071">*</span>信息获取是指拜访用户时发现的可能会转化为订单的需求</div>
					<div style="display:flex;justify-content:center">
						<el-button class="h-btn h-formBtn" type="primary" @click="gotoxuqiu(qdetail)">确定</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import ss from '../../api/SystemService'
	import updownfile from '../../utils/updownfile'
	import uploadexcel from '../../components/uploaddown/uploadexcel'
	import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
	// const cityOptions = [1,2,3,4,5,6,7,8,9];
	export default {
		components: {
			uploaddownexcel,
			uploadexcel
		},
		data() {
			return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
				showOrhide: false,
				status: 1,
				checked: true,
				toshow: "shijipaodong1",
				gly: false,
				//交互照片
				PhotoList: [],
        srcList:[],//交互图片预览
				imgbase: null,
				//上传
				uploaddownexcelflag: false,

				//切换
				indx: 0,
				list: ['全部', '已完成', '未完成', '未开始'],
				xuqiuList: ['资源需求', '信息获取'],
				xuqiudex: 0,
				//表单
				tdate: new Date(),
				q: {
					pageSize: 10,
					pageNo: 1,
					total: 0,
				},
				qdetail: {},
				//全选
				checkedCities: [],
				cities: this.cityOptions,
				cityOptions: [],
				checkAll: false,
				multipleSelection: [],
				//弹出框
				dialogFormVisible: false,
				dialogFormVisible1: false,
				tableData: [],
				formLabelAlign2: [{
					name1: "",
					name2: "",
					name3: "",
					name4: "",
					name5: "",
					name6: "",
					name7: "",
					name8: "",
					name9: "",
					name10: "",
					name11: "",
					name12: "",
				}],
				rules2: {

				},
				chartPer: {
					all: 0,
					done: 0,
					todo: 0,
					undo: 0
				},
				detailShow: false,
				detailShow2: false,
				detailShow3: false,
				planList: [{}],
				//用户名称下拉选
				optionsCustomer: [],
				ifchart: true, //是否展示饼图
				options: {}
			}
		},
		methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
			uploadExcelFilecallback(rd) {
				//this.$msg.alert(rd);
				console.log("回调", rd);
			},
			uploaddownexcelflagbtn() {
				var planstatus = 0;
				ss.UserCare.weekPlanStatus().then(rd => {
					console.log(rd, "点击新建周计划判断");
					if (rd.obj && rd.obj.length > 0) {
						planstatus = rd.obj[0].planStatus;
						if (planstatus == 1) {
							this.$msg.msge("周计划已提交，请等待审核");
						} else if (planstatus == 2) {
							this.$msg.msge("周计划已生成，请勿重复操作");
						} else {
							this.uploaddownexcelflag = true;
						}
					} else {
						this.uploaddownexcelflag = true;
					}
				})
			},
			weekplanCreate() {
				//创建周计划，查询当前用户下周计划状态
				var planstatus = 0;
				ss.UserCare.weekPlanStatus().then(rd => {
					console.log(rd, "点击新建周计划判断");
					if (rd.obj && rd.obj.length > 0) {
						planstatus = rd.obj[0].planStatus;
						if (planstatus == 1) {
							this.$msg.msge("周计划已提交，请等待审核");
						} else if (planstatus == 2) {
							this.$msg.msge("周计划已生成，请勿重复操作");
						} else {
							this.$router.push("/weekplan");
						}
					} else {
						this.$router.push("/weekplan");
					}
				})
			},
			subplan(){
				this.$router.push("/submissionplan");
			},
			gotoxuqiu(value) {
				console.log(this.xuqiudex)
				if (this.xuqiudex == 0) {
					this.$router.push({
						path: '/transforming_demand2',
						query: {
							id: value.executionId
						}
					});
					this.dialogFormVisible1 = false;
				} else if (this.xuqiudex == 1) {
					this.$router.push({
						path: '/transforming_demand1',
						query: {
							id: value.executionId
						}
					})
					this.dialogFormVisible1 = false;
				}
			},

			xuqiuGo(index) {
				this.xuqiudex = index;
			},
			tabIndex(i) {
				this.indx = i;
				this.q.chartAll = i;
				console.log(this.indx);
				console.log(this.q.chartAll);
				this.detailShow = false;
				this.query();
				// this.chartP();
				if (i == 1) {
					this.options.series.data = [{
							value: this.chartPer.done,
							name: '已拜访',
							selected: true
						},
						{
							value: this.chartPer.todo,
							name: '未开始',
						},
						{
							value: this.chartPer.undo,
							name: '未完成',
						}
					];
				} else if (i == 2) {
					this.options.series.data = [{
							value: this.chartPer.done,
							name: '已拜访',

						},
						{
							value: this.chartPer.todo,
							name: '未开始',
						},
						{
							value: this.chartPer.undo,
							name: '未完成',
							selected: true
						}
					];
				} else if (i == 3) {
					this.options.series.data = [{
							value: this.chartPer.done,
							name: '已拜访',

						},
						{
							value: this.chartPer.todo,
							name: '未开始',
							selected: true
						},
						{
							value: this.chartPer.undo,
							name: '未完成',

						}
					];
				} else {
					this.options.series.data = [{
							value: this.chartPer.done,
							name: '已拜访',

						},
						{
							value: this.chartPer.todo,
							name: '未开始',
						},
						{
							value: this.chartPer.undo,
							name: '未完成',

						}
					];
				}

				this.getPieChartAc();
				this.ifchart = true; //展示饼图
			},
			getimgId(id) {
				ss.UserCare.imgDown(id).then(data => {
					console.log(data)
					var imgbase = 'data:image/png;base64,' + btoa(new Uint8Array(data.data).reduce((data, byte) => data + String.fromCharCode(
						byte), ''))
					if (imgbase) {
						this.PhotoList.push({
							saveurl: imgbase,
						})
            this.srcList.push(imgbase)
					}
				})
			},
			checkDetail(value) {
				if (value) {
					this.PhotoList = [];
					this.detailShow = true;
					ss.UserCare.planDetail({
						id: value
					}).then(rd => {
						this.qdetail = rd.plan;
						if (rd.plan.userCareExecution.carePhoto) {
							for (var i = 0; i < rd.plan.userCareExecution.carePhoto.length; i++) {
								this.getimgId(rd.plan.userCareExecution.carePhoto[i].id)
							}
						}
						if (rd.plan.userCareExecution) {
							this.detailShow2 = true;
							console.log(rd.plan.userCareExecution, "111111111111111111111")
							if (rd.plan.userCareExecution.transform != 0) {
								this.detailShow2 = false;
								this.detailShow3 = true;
							}
						} else {
							this.detailShow2 = false;
						}
						console.log("aaa", this.detailShow2, this.detailShow3);
					});

					this.ifchart = false; //隐藏饼图
				} else {
					this.detailShow = false;
					this.detailShow2 = false;
					this.detailShow3 = false;
				}

			},
			handleCheckAllChange(val) {
				console.log(val)
				this.checkedCities = val ? this.cityOptions : [];
			},
			handleCheckedCitiesChange(value) {
				this.multipleSelection = value;
				console.log(this.multipleSelection, "勾选时的值");
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cityOptions.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cityOptions.length;
			},
			getPieChartAc() {
				let h_gaugePie = this.$echarts.init(document.getElementById('h_gaugePie'));
				let placeHolderStyle = {
					normal: {
						color: 'rgba(0,0,0,0)',
						label: {
							show: false
						},
						labelLine: {
							show: false
						}
					},
					emphasis: {
						color: 'rgba(0,0,0,0)'
					}
				};
				console.log(this.options)
				h_gaugePie.setOption(this.options);
			},
			getPieChart() {
				let h_gaugePie = this.$echarts.init(document.getElementById('h_gaugePie'));

				this.options = {
					tooltip: {
						show: true,
					},
					legend: {
						show: false
					},
					grid: {
						left: 0,
						top: 0,
						right: 0,
						bottom: 0
					},
					color: ['#32b16c', '#2c90ff', '#ffb72c'],
					series: {

						type: 'pie',
						selectedOffset: 10,

						radius: "70%",
						center: ['50%', '50%'],

						labelLine: {
							normal: {
								show: true,
								length: 10,
								length2: 10
							}
						},
						label: {
							show: true,
							formatter: '{b}{c}',
						},
						data: [{
								value: this.chartPer.done,
								name: '已拜访',
							},
							{
								value: this.chartPer.todo,
								name: '未开始',
							},
							{
								value: this.chartPer.undo,
								name: '未完成',
							}
						]
					}
				}

				h_gaugePie.setOption(this.options, true);
			},
			//表格
			handleFilter() {
				this.query();
				this.chartP();
				this.detailShow = false;
			},
			reset() {
				this.q = {
					pageSize: this.q.pageSize,
					pageNo: this.q.pageNo,
					total: this.q.total
				}
			},
			query() {
				this.gly = this.$store.getters.hasRole("swyl_admin,swyl_guanhgly");
				ss.UserCare.selectPage(this.q).then(rd => {
					console.log(rd, "左面表格");
					this.q.total = rd.total;
					this.tableData = rd.records;
					for (let i = 0; i < this.tableData.length; i++) {
						this.cityOptions.push(i + 1);
					}
				})
			},
			chartP() {
				ss.UserCare.planChart(this.q).then(rd => {
					console.log(rd, "右边图表");
					this.chartPer.all = rd.chartNum.chartAll;
					this.chartPer.done = rd.chartNum.chartDone;
					this.chartPer.todo = rd.chartNum.chartTodo;
					this.chartPer.undo = rd.chartNum.chartUndo;
					this.getPieChart();
				})
			},
			transforxq() {
				// this.$router.push("/xuqiu");
				this.dialogFormVisible1 = true;
			},
			addPlan() {
				this.dialogFormVisible = true;
				this.selectCustomer();
			},
			selectCustomer() {
				ss.ProService.customerSelect().then(rd => {
					// console.log("客户名称下拉", rd)
					this.optionsCustomer = rd;
				})
			},
			addplanList() {
				var a = {}
				this.planList.push(a)
			},
			delplanList() {
				this.planList.splice(0, 1)
			},
			//明细导出
			exportExcel() {
				//ids
				console.log(this.multipleSelection);
				var cc = [];
				this.multipleSelection.forEach((item, index) => {
					console.log(item, "sadas");
					console.log(this.tableData)
					cc.push(this.tableData[item - 1].id);
				})
				//查询参数
				var c = {
					chartAll: this.q.chartAll,
					euNameLike: this.q.euNameLike,
					planTimeStartBegin: this.q.planTimeStartBegin,
					planTimeEndEnd: this.q.planTimeEndEnd,
					euType: this.q.euType,
					ids: cc,
				};
				console.log('导表参数', c);

				// this.$export.exportData("/guanhuai/userCareExcel/downloadExcel",this.q)
				updownfile.down("/api/swyl/v1/guanhuai/userCarePlan/downloadExcel", c, "post", 'data');
			},
			//时间限制
			beginDate(v) {
				if (v.planTimeEndEnd) { //如果结束时间不为空，则小于结束时间
					if (v.planTimeEndEnd < v.planTimeStartBegin) {
						this.$msg.msge("结束日期不能小于开始日期");
						v.planTimeStartBegin = "";
					}
				}
			},
			processDate(v) {
				if (v.planTimeStartBegin) { //如果有出厂日期
					//如果购买日期小于出厂日期
					if (v.planTimeEndEnd < v.planTimeStartBegin) {
						this.$msg.msge("结束日期不能小于开始日期");
						v.planTimeEndEnd = "";
					}
				}
			},
			showzhezhao() {
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
					if (rd == false) {
						this.showOrhide = false;
					} else {
						this.showOrhide = true;
					}
				})
			},
			// 关闭新手引导页
			closeIt() {
				this.showOrhide = false;
				if (this.checked) {
					ss.salesList.toshow(this.toshow, this.checked).then(rd => {
						console.log(rd);
						 this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow, this.checked).then(rd => {
						console.log(rd) ;
						this.showOrhide = false;
					})
				}
			},
			nextStep(i) {
				if (this.status == 1) {

					if (this.checked) {
						ss.salesList.toshow(this.toshow, this.checked).then(rd => {
							console.log(rd);
							this.showOrhide = false;
						})
					} else {
						ss.salesList.toshow(this.toshow, this.checked).then(rd => {
							console.log(rd);
							this.showOrhide = false;
						})
					}
				}
			}
		},
		mounted() {
			this.query();
			this.chartP();
			this.options = {
				tooltip: {
					show: true,
				},
				legend: {
					show: false
				},
				grid: {
					left: 0,
					top: 0,
					right: 0,
					bottom: 0
				},
				color: ['#32b16c', '#2c90ff', '#ffb72c'],
				series: {
					type: 'pie',
					selectedOffset: 10,
					radius: "70%",
					center: ['50%', '50%'],
					labelLine: {
						normal: {
							show: true,
							length: 10,
							length2: 10
						}
					},
					label: {
						show: true,
						formatter: '{b}{c}',
					},
					label: {
						show: false,
					},
					data: []
				}
			}
		},
		created() {
			this.showzhezhao()
		}
	}
</script>

<style scoped>
	.cuname {
		font-size: 0.16rem;
		color: #323232;
	}

	.h-todoCheck a {
		font-size: 0.16rem;
		color: #323232;
		display: inline-block;
		vertical-align: top;
		max-width: 2.9rem;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: inline-block;
	}

	.selectbbbb {
		display: flex;
		align-items: center;
		border-bottom: 2px solid #f9f9f9;
	}

	.selectbbbb:hover {
		background: #f5fcff;
	}

	.h-gaugePieLegend .h-gpLegendLi i {
		margin-top: -12px;
	}

	.totals {
		text-align: center;
		font-size: 0.22rem;
		color: #282828;
		margin-bottom: 20px;
	}

	.h-formLines {
		padding: 30px 48px;
	}

	.xuqiuBoxList {
		width: 100%;
		margin-top: 30px;
		display: flex;
		justify-content: space-between;
	}

	.xuqiuBoxList .xuqiulist {
		width: 215px;
		height: 62px;
		border-radius: 4px;
		background: #fff;
		border: 1px solid #959595;
		text-align: center;
		line-height: 62px;
		color: #989898;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.xuqiuBoxList .xuqiulist.active {
		background: #238cfd;
		border: 1px solid #238cfd;
		color: #fff;
	}

	.xuqiutext {
		color: #bcbcbc;
		font-size: 14px;
		margin-bottom: 14px;
	}

	.planList {
		margin-top: 40px;
	}

	.planList:first-child {
		margin-top: 0
	}

	.timesdetail {
		width: 5rem;
	}
</style>
<style>
	.selectcheckbox .el-checkbox:hover {
		background: 0
	}

	/* .selectcheckbox .el-checkbox {
		margin-bottom: 5px
	} */

	.selectcheckbox .el-checkbox__label {
		display: none
	}

	.h-formLines .h-btn.el-button {
		background: #238cfd;
		border-color: #238cfd;
		width: 100px;
		height: 50px;
	}

	.h-dialogForm .h-regionForm .el-form-item__label {
		width: 24%;
	}

	.h-dialogForm .h-regionForm .el-form-item__content {
		width: 76%;
	}

	.fenyes .el-pagination .el-pagination__sizes {
		display: none;
	}

	.h-formBorder .timesdetail .el-form-item__content {
		width: 80%
	}
</style>
<style scoped lang="scss">
	.bottomTip {
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}

	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}

	.leaderBox {
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;

		.leaderbg {
			width: 100%;
			height: 100%;
		}

		.steps {
			position: absolute;
			z-index: 1;
		}

		.step1 {
			top: -0.7rem;
			left: 0;
		}

		.stepbtn {
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0, 0, 0, 0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}

		.closeIt {
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>
